import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUpdateEntry } from '../types';

const onUpdateEntry: IThunkUpdateEntry = thunk(async (_, { entryId, entry, ...client }) => {
  await api.communityEngagement.updateEntry(client, entryId, entry);
});

export default onUpdateEntry;
